export default async function withRetry<T>(fn: () => Promise<T>, retries = 3) {
  let attempt = 0;
  let lastError: unknown;

  while (attempt < retries) {
    try {
      return await fn();
    } catch (e) {
      lastError = e;
      attempt++;
      await new Promise((r) => setTimeout(r, 300 * Math.pow(2, attempt)));
    }
  }

  throw lastError;
}
